import React, { useState} from 'react'
import { HiOutlineMinus,  HiChevronDown, HiChevronUp } from "react-icons/hi";

const Reminders = () => {

	const [isReminder, setIsReminders] = useState(false)

	const styles = {
		classes: {
		  divL: 'md:w-3/4 px-4 md:px-0 mx-auto text-lg my-5',
		  divS: 'md:w-3/4 px-4 md:px-5 mx-auto text-lg my-5',
		  h3: 'text-2xl mb-2',
		  ul: 'list-disc px-4 md:px-6 my-2'},
	}

	const remidersRules = [
		{id: 1, text: 'Klient si může zvolit zástupce (příp. tlumočníka), který ho bude při vyřizování stížnosti zastupovat (příbuzný, rodinný přítel, instituce).'},
		{id: 2, text: 'Účastníci vyřizování stížností: klient, blízké osoby – na přání klienta, pracovník organizace, který vyřizuje stížnost (příp. další pracovníci – dle přání klienta).'},
		{id: 3, text: 'Postupy k prověřování stížností voleny tak, aby: vedly k rychlému zjištění skutečného stavu,   nesnižovaly důstojnost žádného z účastníků, neovlivňovaly nežádoucím způsobem budoucí vztahy.'},
		{id: 4, text: 'Všechny stížnosti ústní i písemné jsou evidovány - zápis do Knihy stížností a připomínek.'},
		{id: 5, text: 'Anonymní stížnosti: možno vhodit do poštovní schránky sídla organizace v ul. J. z Poděbrad čp. 2046, Sokolov (přízemí, proti hlavnímu výtahu, spodní řada schránek).'},
		{id: 6, text: 'Jejich prošetření: nejpozději do 7 dnů, příp. přijatá opatření anonymních stížností zveřejněna na zdejší nástěnce po dobu 14 dní.'},
		{id: 7, text: 'Agenda stížností: je pravidelně analyzována na provozních poradách organizace, závěry jsou využity ke zlepšení kvality a zdokonalování forem poskytovaných služeb.'},
	]

  return (
	<section id='reminders' className='px-2 py-3 mb-10 bg-cyan-800 text-white'>
		<div className='container mx-auto'>
			<div className='text-center my-3'>
				<h2 className='text-4xl w-fit mx-auto border-b-2 mb-3 border-amber-500 uppercase'>
					Řešení stížností a připomínek
				</h2>
				<p className='inline-flex text-lg cursor-pointer shadow-md shadow-gray-600 border text-black rounded p-2 w-fit mx-auto bg-gray-100 hover:bg-amber-500' onClick={()=>setIsReminders(!isReminder)}>
					{
						isReminder ? <HiChevronUp className='text-3xl me-2'/> : <HiChevronDown className='text-3xl me-2'/>
					}
					informace o podávání stížností</p>
			</div>
			{
				isReminder ? (
					<div className={`${styles.classes.divS} h-full opacity-1 transition-opacity duration-800 ease-in-out`}>
						<div className='mb-2'>
							<p className='mb-2'>
							Klienti jsou poučeni o možném podávání stížností a postupu při jejich vyřizování:
							</p>
							<ul className={styles.classes.ul}>
								<li>
									při vstupním pohovoru - při zavedení peč. služby.
								</li>
								<li>
									postup je součástí souboru informací o organizaci (Standardy kvality - standard č.7).
								</li>
							</ul>
						</div>
						
						<div className='mb-2'>
							<p className='mb-2'>
								Stížnosti přijímají a vyřizují:  vedoucí pracovníci:
							</p>
							<ul className={styles.classes.ul}>
								<li>
									v objektu na adrese J. z Poděbrad 2046, Sokolov (bývalý tzv. DPS): soc. pracovník, ředitelka organizace.
								</li>
								<li>
									v terénu (mimo tento objekt) vedoucí pečovatelka pro terén – Sokolov a obce.
								</li>
							</ul>
						</div>
						<div className='mt-4 mb-2'>
							<ul className=''>
								{
									remidersRules.map(oneRule => (
										<li key={oneRule.id} className='flex'>
											<HiOutlineMinus className='text-white text-2xl me-2 pt-2'/>  {oneRule.text}
										</li>
									))

								}
							</ul>
						</div>
					</div>
				) : <div className='h-0 opacity-0'></div>
			}
			
		</div>
	</section>
  )
}

export default Reminders
